'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');

var SchemaMismatchError = /** @class */ (function (_super) {
    tslib.__extends(SchemaMismatchError, _super);
    /**
     * Creates a new SchemaMismatchError error
     * @param channel - name of event channel
     * @param schema - registered schema on event channel
     * @param newSchema - new schema attempting to be registered on event channel
     */
    function SchemaMismatchError(channel, schema, newSchema) {
        var _this = _super.call(this, "schema registration for [" + channel + "] must match already registered schema.") || this;
        _this.channel = channel;
        _this.schema = schema;
        _this.newSchema = newSchema;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, SchemaMismatchError);
        }
        _this.name = 'SchemaMismatchError';
        return _this;
    }
    return SchemaMismatchError;
}(Error));

exports.SchemaMismatchError = SchemaMismatchError;
